<template>
    <v-container fluid @click="menu = false">
        <v-row justify="center">
            <v-col cols="12" xl="4" class="text-center">
                <label-component fontWeight="bold">テンプレート管理</label-component>
            </v-col>
            <v-col cols="12" xl="4" class="text-right">
                <v-btn color="red" class="white--text" x-large @click="createTemplate()">テンプレートの新規作成</v-btn>
                <v-btn color="red" class="white--text" x-large @click="createMultipleTemplate()">一括送信テンプレートの新規作成</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col col="auto">
                <v-tabs 
                    dark 
                    background-color="grey" 
                    show-arrows 
                    v-model="tab"
                >
                    <v-tab class="tab" v-for="tab in tabs" :key="tab" active-class="white">
                        {{ tab }}
                    </v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-tabs-items v-model="tab">
            <v-tab-item>
            <!-- オリジナルテンプレート -->
            <v-row justify="center">
                    <v-col cols="12">
                        <v-data-table
                            :items="originalItems"
                            item-key="id"
                            :server-items-length="originalItemsLength"
                            disable-sort
                            :loading="loading"
                            hide-default-header
                            hide-default-footer
                        >
                            <template v-slot:body="props">
                                <tbody>
                                    <tr v-for="(item, index) in props.items" :key="item.id">
                                        <td align="left" width="75%;" style="padding-left:20px!important;">
                                            {{ item.template_name }}
                                        </td>
                                        <td align="center">
                                            <v-btn color="blue" class="white--text" @click="toOverView(item.object_id)">概要</v-btn>
                                        </td>
                                        <td align="center">
                                            <v-btn color="orange" class="white--text" @click="editTemplate(item.object_id)">編集する</v-btn>
                                        </td>
                                        <td align="center">
                                            <v-btn color="blue-grey" class="white--text" @click="deleteDialog(item)">削除</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>
            
            <!-- 一括送信テンプレート -->
            <v-tab-item>
                <v-row justify="center">
                    <v-col cols="12">
                        <v-data-table
                            :items="multipleItems"
                            item-key="id"
                            :server-items-length="multipleItemsLength"
                            disable-sort
                            :loading="loading"
                            hide-default-header
                            hide-default-footer
                        >
                            <template v-slot:body="props">
                                <tbody>
                                    <tr v-for="(item, index) in props.items" :key="item.id">
                                        <td align="left" width="75%;" style="padding-left:20px!important;">
                                            {{ item.template_name }}
                                        </td>
                                        <td align="center">
                                            <v-btn color="blue" class="white--text" @click="toMultipleOverView(item.object_id)">概要</v-btn>
                                        </td>
                                        <td align="center">
                                            <v-btn color="orange" class="white--text" @click="editMultipleTemplate(item.object_id)">編集する</v-btn>
                                        </td>
                                        <td align="center">
                                            <v-btn color="blue-grey" class="white--text" @click="deleteDialog(item)">削除</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>
            
            <!-- 公式テンプレート -->
            <v-tab-item>                 
                <v-row justify="center">
                    <v-col cols="12">
                        <v-data-table
                            :items="officialItems"
                            item-key="id"
                            :server-items-length="officialItemsLength"
                            disable-sort
                            :loading="loading"
                            hide-default-header
                            hide-default-footer
                        >
                            <template v-slot:body="props">
                                <tbody>
                                    <tr v-for="(item, index) in props.items" :key="item.id">
                                        <td align="left" width="75%;" style="padding-left:20px!important;">
                                             <badge-component tile content="公式" color="blue">
                                                {{ item.template_name }}
                                            </badge-component>
                                        </td>
                                        <td align="center">
                                            <v-btn color="blue" class="white--text" @click="toOverView(item.object_id)">概要</v-btn>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>
        
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
        
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="dialog.confirmDelete" :dialog.sync="dialog.confirmDelete" @clickOk="deleteTemplate(currentItem)"
            :message="currentItem.template_name + 'を削除しますか？'" okBtn="削除" cancelbtn="キャンセル">
        </simple-dialog-component>
        
    </v-container>
</template>
<script>
    export default {
        data() {
            return {
                // ダイアログ開閉フラグ
                dialog: {
                    confirmDelete: false,
                },
                tabs: [
                  'オリジナルテンプレート', '一括送信テンプレート', '公式テンプレート',
                ],
                tab: null,
                // 現在の項目
                currentItem: null,
                // オリジナルテンプレート
                originalItems: [],
                // 一括送信テンプレート
                multipleItems: [],
                // 公式テンプレート
                officialItems: [],
                // 項目の数
                originalItemsLength: 0,
                multipleItemsLength: 0,
                officialItemsLength: 0,
                message: {
                    success: false,
                    text: "",
                },
                // 読込中表示
                loading: true,
            }
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        created : function() {
            // 初期表示
            this.getItems();
        },
        methods: {
            // 項目の取得
            getItems() {
                this.loading = true;
                axios.get('/documents/document-management/template/get-items').then(res => {
                    this.originalItems = res.data.originalTemplates;
                    this.multipleItems = res.data.multipleTemplates;
                    this.officialItems = res.data.officialTemplates;
                    this.originalItemsLength = res.data.originalTemplates.length;
                    this.multipleItemsLength = res.data.multipleTemplates.length;
                    this.officialItemsLength = res.data.officialTemplates.length;
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 削除ダイアログ
            deleteDialog(item) {
                this.currentItem = item;
                this.dialog.confirmDelete = true;
            },
            // 削除
            deleteTemplate(item) {
                axios.delete('/documents/document-management/template/' + item.object_id + '/delete').then(res => {
                    if (res.data.success) {
                        var index = this.originalItems.indexOf(item);
                        if (index >= 0){
                            this.originalItems.splice(index, 1);
                        }
                        var index = this.multipleItems.indexOf(item);
                        if (index >= 0){
                            this.multipleItems.splice(index, 1);
                        }
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                });
            },
            // 新規作成
            createTemplate() {
                window.location = "template/new";
            },
            // 一括送信テンプレート新規作成
            createMultipleTemplate() {
                window.location = "multiple-send-template/new";
            },            
            // 編集
            editTemplate(uid) {
                window.location = "template/" + uid + "/info";
            },
            // 編集
            editMultipleTemplate(uid) {
                window.location = "multiple-send-template/" + uid + "/info";
            },
            // 契約概要画面へ
            toOverView(uid) {
                window.location = '/documents/document-management/template/' + uid + '/over-view';
            },
            // 契約概要画面へ
            toMultipleOverView(uid) {
                window.location = '/documents/document-management/multiple-send-template/' + uid + '/over-view';
            },
        }
    }
</script>

<style scoped>
    ::v-deep td {
        padding: 5px 0!important;
    }
</style>
